<script lang="ts">
import {defineComponent} from 'vue'
import MockUpMain from "@/view/pages/businessPage/components/mockUp.vue";
import UniversalQrModal from '../../components/UniversalQrModal.vue';

export default defineComponent({
  name: "viewMultiCard",
  components: {
    MockUpMain,
    UniversalQrModal
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  qrSvgDataUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return{
      showQrDialog:false,
    }
  },
  computed: {
    cardStyle() {
      const bg = this.value.pallete.bodyColor || "";
      return {
        background: bg || '#ffffff', 
        height: '100%'
      };
    },
    buttonStyle() {
      const bg = this.value.pallete.buttonColor || "";
      return {
        background: bg || '#ffffff', 
      };
    },

    textStyle() {
      const text = this.value.pallete.textColor || "";
      return {
        color: text || '#ffffff', 
        height: '100%'
      };
    }


  }
})
</script>

<template>
  <mock-up-main>
    <v-card
        class="mx-auto overflow-hidden"
        max-width="500"
        :style="cardStyle"
    >
    <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کیوآر مولتی کارت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>


      <!-- تصویر هدر -->
      <v-img
          v-if="value.infoUser.background"
          height="200px"
          :src="value.infoUser.background"
          alt="تصویر اصلی"
      ></v-img>


      <!-- بخش اطلاعات پروفایل -->
      <v-list-item two-line class="pa-3">
        <!-- آواتار -->
        <v-list-item-avatar v-if="value.infoUser.logoImage" size="60" color="grey lighten-2">
          <v-img
              :src="value.infoUser.logoImage"
              alt="تصویر کوچک"
          ></v-img>
        </v-list-item-avatar>

        <!-- نام و زیرعنوان -->
        <v-list-item-content>
          <v-list-item-title :style="textStyle" class="text-h6 font-weight-bold mb-1">
            <!-- استفاده از Optional Chaining (?.) برای جلوگیری از ارور -->
            {{ value?.infoUser?.nameCollection || "نام مجموعه" }}
          </v-list-item-title>

          <v-list-item-subtitle :style="textStyle" class="mt-1 caption font-weight-bold">
            {{ value?.infoUser?.subTitle || "زیر عنوان" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- بخش ورودی‌ها و دکمه -->
      <div class="px-4 pb-4">
        <v-text-field
            label="مبلغ واریزی"
            value="20,000,000"
            outlined
            dense
            hide-details
            class="mb-4 white--text field-styled"
            background-color="white"
            append-icon="mdi-credit-card"
        />
        <v-btn
            block
            :style="buttonStyle"
            class="white--text font-weight-bold"
            large
        >
          <p class="m-0 font-weight-bold" :style="textStyle">ادامه</p>
        </v-btn>
      </div>

    </v-card>
  </mock-up-main>
</template>

<style scoped>
.field-styled >>> .v-input__slot {
  /* background: rgba(255,255,255,0.9) !important; */
}
.qr-floating-btn {
  position: absolute;
  top: 24px;
  left: 24px;
  z-index: 20;
  background-color: rgba(196, 139, 7, 0.9) !important;
  color:white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3); 
  padding: 15px !important;
}

</style>